import * as d3 from 'd3'

const color_scales = {
    total: {
        title: 'Actual PB\u00A0+\u00A0WP',
        precision: 0,
        fn: (bin) => d3.sum(bin, (d) => d.is_runner_pbwp),
    },
    density: {
        title: 'Block Opportunities',
        precision: 0,
        fn: (bin) => bin.length,
    },
    exp_pbwp: {
        title: 'Estimated PB\u00A0+\u00A0WP',
        precision: 0,
        fn: (bin) => d3.sum(bin, (d) => d.x_runner_pbwp),
    },
    exp_pbwp_per_pitch: {
        title: 'Avg. PB\u00A0+\u00A0WP Per Pitch',
        precision: 1,
        fn: (bin) => d3.mean(bin, (d) => d.x_runner_pbwp),
    },
    exp_pbwp_added: {
        title: 'Blocks Above Avg',
        precision: 1,
        fn: (bin) => d3.sum(bin, (d) => d.x_runner_pbwp - d.is_runner_pbwp),
    },
    exp_pbwp_added_per_40: {
        title: 'Blocks Above Avg / Game',
        precision: 1,
        fn: (bin) =>
            bin.length
                ? d3.mean(bin, (d) => d.x_runner_pbwp - d.is_runner_pbwp) * 40
                : 0,
    },
}

// Calculate given _all_ the bins
export default function calculateScales(bins) {
    const just_bins = bins.map((d) => d.bin)
    const density_max = d3.max(just_bins, color_scales.density.fn)
    const density_color_scale = d3
        .scaleSequential(d3.interpolateReds)
        .domain([0, density_max])
        .clamp(true)

    const total_pbwp_max = Math.round(
        Math.max(d3.max(just_bins, color_scales.total.fn), 1)
    )
    const exp_pbwp_max = d3.max(just_bins, color_scales.exp_pbwp.fn)

    const pbwp_max = Math.max(total_pbwp_max, exp_pbwp_max)

    const total_pbwp_color_scale = d3
        .scaleSequential(d3.interpolateReds)
        .domain([0, pbwp_max])
        .clamp(true)

    const exp_pbwp_color_scale = d3
        .scaleSequential(d3.interpolateReds)
        .domain([0, pbwp_max])
        .clamp(true)

    // const [exp_pbwp_added_min, exp_pbwp_added_max] = d3.extent(just_bins, color_scales.exp_pbwp_added.fn)
    const exp_pbwp_added_color_scale = d3
        .scaleSequential(d3.interpolateRdBu)
        .domain([1, -1])
        .clamp(true)

    // const exp_pbwp_per_pitch_max = d3.max(
    //     just_bins,
    //     color_scales.exp_pbwp_per_pitch.fn
    // )
    const exp_pbwp_per_pitch_color_scale = d3
        .scaleSequential(d3.interpolateRdBu)
        .domain([0.2, 0])
        .clamp(true)

    const exp_pbwp_added_per_40 = d3
        .scaleSequential(d3.interpolateRdBu)
        .domain([0.5, -0.5])
        .clamp(true)

    color_scales.total.scale = total_pbwp_color_scale
    color_scales.density.scale = density_color_scale
    color_scales.exp_pbwp.scale = exp_pbwp_color_scale

    color_scales.exp_pbwp_per_pitch.scale = exp_pbwp_per_pitch_color_scale

    color_scales.exp_pbwp_added.scale = exp_pbwp_added_color_scale
    color_scales.exp_pbwp_added_per_40.scale = exp_pbwp_added_per_40

    return color_scales
}
